module.exports = __webpack_public_path__ + "static/media/kalysco.26fa7870.png";